import { render } from "./GastoCorrienteComponent.vue?vue&type=template&id=9667cce2&scoped=true"
import script from "./GastoCorrienteComponent.vue?vue&type=script&lang=js"
export * from "./GastoCorrienteComponent.vue?vue&type=script&lang=js"

import "./GastoCorrienteComponent.vue?vue&type=style&index=0&id=9667cce2&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9667cce2"]])

export default __exports__